import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestCostsacct } from "../../entity/EntityRequestCostsacct";

export class DtoRequestCostsacctsPostReq extends EntityRequestCostsacct {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
